import { Link } from "react-router-dom";

const Content = (props) => {
    const { data } = props;
    return(
        <div className="container">
            <Link to="/"><div className="x-btn"></div></Link>
            <h1>{data?.name}</h1>
            <h2>{data?.weather[0].main}</h2>
            <div className="texts-group">
                <div className="texts">
                    <p>기온 <span className="temp"/> : {data?.main.temp} °C</p>
                    <p>max <span className="temp"/> : {data?.main.temp_max} °C</p>
                    <p>min <span className="temp"/> : {data?.main.temp_min} °C</p>
                </div>
                <div className="texts">
                    <p>풍향 <span className="wind"/> : {data?.wind.deg}</p>
                    <p>속도 <span className="wind"/> : {data?.wind.speed}</p>
                </div>
            </div>
        </div>
    )
}

export default Content